import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { useEnvironment } from '../../context/EnvironmentContext';

type Variant = 'primary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

export function Button({
  variant = 'primary',
  className = '',
  type = 'button',
  disabled,
  children,
  ...props
}: ButtonProps) {
  const { isSandbox } = useEnvironment();
  const accent = isSandbox
    ? 'bg-onyx-purple text-white hover:bg-onyx-purple-dim shadow-purple'
    : 'bg-onyx-gold text-onyx-bg hover:bg-onyx-gold-dim shadow-gold';

  const styles: Record<Variant, string> = {
    primary: accent,
    ghost: 'border border-onyx-border text-onyx-text hover:bg-onyx-elevated',
    danger: 'bg-onyx-danger/90 text-white hover:bg-onyx-danger',
  };

  return (
    <button type={type} disabled={disabled} className={`btn-primary ${styles[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
